import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export default styled.div`
  animation: ${fadeIn} ${props => props.duration ? props.duration : .5}s ease forwards;
  animation-delay: ${ props => props.delay ? props.delay : 0}s;
`